/** Estilo comun de los graficos (recharts) para que sigan el tema claro/oscuro: todo por variables CSS, nunca colores fijos. */
import type { StepTone } from '../lib/activityStepper';

export const TIP = {
  contentStyle: { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6, fontSize: 12, color: 'var(--ink)' },
  itemStyle: { color: 'var(--ink)' },
  cursor: { fill: 'var(--sunken)' },
};
export const AXIS_TICK = { fill: 'var(--ink-muted)', fontSize: 12 };

/** Color de cada tono del flujo de la actividad (el mismo que pinta el hito actual y la pastilla de estado). */
export const TONE_COLOR: Record<StepTone, string> = {
  info: 'var(--brand-gray)',
  accent: 'var(--brand)',
  warning: 'var(--warning)',
  success: 'var(--success)',
  neutral: 'var(--ink)',
};

/** Recorta un rotulo largo para el eje; el tooltip conserva el nombre completo. */
export const clip = (v: string, max = 24) => (v.length > max ? `${v.slice(0, max - 1)}…` : v);
